import { Stack } from "@mui/material";
import React from "react";
import { colors } from "../../assets";
import { ParagraphText, TitleText } from "../atoms";

export const BulletTimeline = ({ items }) => {
  return (
    <Stack>
      {items?.map((item, index) => (
        <Stack key={index} direction="row" spacing="24px">
          <Stack alignItems="center" style={{ width: "12px" }}>
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                backgroundColor: colors.primary,
                flexShrink: 0,
              }}
            />
            {index < items.length - 1 && (
              <div
                style={{
                  width: "2px",
                  flex: 1,
                  backgroundColor: colors.gray4,
                }}
              />
            )}
          </Stack>

          <Stack spacing="8px" style={{ paddingBottom: "32px" }}>
            <TitleText style={{ fontSize: "20px" }}>{item?.title}</TitleText>
            <ParagraphText>{item?.description}</ParagraphText>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
